// Definindo os tipos
enum CodigoMulta {
  SEM_MULTA = 'Sem Multa',
  FIXA = 'Multa Fixa',
  PERCENTUAL = 'Multa Percentual'
}

enum CodigoMora {
  SEM_MORA = 'Sem Mora',
  FIXA = 'Mora Fixa',
  PERCENTUAL = 'Mora Percentual'
}

enum TypePessoa {
  FISICA = 'Pessoa Física',
  JURIDICA = 'Pessoa Jurídica'
}

// Componente principal
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select'
import { Button } from '@/components/ui/button'

interface GerarBoletoProps {
  onClose: () => void // Tipagem correta para a prop onClose
}

export default function GerarBoleto({ onClose }: GerarBoletoProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Gerar Boleto</CardTitle>
          <CardDescription>Preencha os campos abaixo para gerar um novo boleto.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 max-h-[70vh] overflow-y-auto">
          <div className="space-y-2">
            <Label htmlFor="nomeBeneficiario">Nome do Beneficiário</Label>
            <Input id="nomeBeneficiario" placeholder="Digite o nome do beneficiário" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="cpfCnpjBeneficiario">CPF/CNPJ do Beneficiário</Label>
            <Input id="cpfCnpjBeneficiario" placeholder="Digite o CPF/CNPJ do beneficiário" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="valor">Valor</Label>
            <Input id="valor" type="number" placeholder="Digite o valor do boleto" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="dataVencimento">Data de Vencimento</Label>
            <Input id="dataVencimento" type="date" placeholder="Digite a data de vencimento" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="seuNumero">Seu Número</Label>
            <Input id="seuNumero" placeholder="Digite o seu número" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="codigoSolicitacao">Código de Solicitação</Label>
            <Input id="codigoSolicitacao" placeholder="Digite o código de solicitação" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="codMulta">Código de Multa</Label>
            <Select>
              <SelectTrigger id="codMulta">
                <SelectValue placeholder="Selecione o código de multa" />
              </SelectTrigger>
              <SelectContent>
                {Object.values(CodigoMulta).map(value => (
                  <SelectItem key={value} value={value}>
                    {value}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label htmlFor="codMora">Código de Mora</Label>
            <Select>
              <SelectTrigger id="codMora">
                <SelectValue placeholder="Selecione o código de mora" />
              </SelectTrigger>
              <SelectContent>
                {Object.values(CodigoMora).map(value => (
                  <SelectItem key={value} value={value}>
                    {value}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label htmlFor="taxaMulta">Taxa de Multa</Label>
            <Input id="taxaMulta" type="number" placeholder="Digite a taxa de multa" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="taxaMora">Taxa de Mora</Label>
            <Input id="taxaMora" type="number" placeholder="Digite a taxa de mora" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="dhEmissao">Data de Emissão</Label>
            <Input id="dhEmissao" type="date" placeholder="Digite a data de emissão" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="dhVencimento">Data de Vencimento</Label>
            <Input id="dhVencimento" type="date" placeholder="Digite a data de vencimento" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="limitePag">Limite de Pagamento</Label>
            <Input id="limitePag" type="number" placeholder="Digite o limite de pagamento" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="dhMora">Data de Mora</Label>
            <Input id="dhMora" type="date" placeholder="Digite a data de mora" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="dhMulta">Data de Multa</Label>
            <Input id="dhMulta" type="date" placeholder="Digite a data de multa" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" placeholder="Digite o email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="telefone">Telefone</Label>
            <Input id="telefone" type="tel" placeholder="Digite o telefone" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="tipoPessoa">Tipo de Pessoa</Label>
            <Select>
              <SelectTrigger id="tipoPessoa">
                <SelectValue placeholder="Selecione o tipo de pessoa" />
              </SelectTrigger>
              <SelectContent>
                {Object.values(TypePessoa).map(value => (
                  <SelectItem key={value} value={value}>
                    {value}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-2">
            <Label htmlFor="endRua">Rua</Label>
            <Input id="endRua" placeholder="Digite a rua" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="endNum">Número</Label>
            <Input id="endNum" placeholder="Digite o número" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="endBairro">Bairro</Label>
            <Input id="endBairro" placeholder="Digite o bairro" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="endCidade">Cidade</Label>
            <Input id="endCidade" placeholder="Digite a cidade" />
          </div>
        </CardContent>
        <CardFooter className="flex justify-between">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button type="submit">Gerar Boleto</Button>
        </CardFooter>
      </Card>
    </div>
  )
}
